import loadingGif from '../assets/img/loading.gif'


const Loading = () => {
    return (
        <div id="loader-container">
            <img src={loadingGif} alt={""}/>
        </div>
    );
};
export default Loading;
